import React from 'react';
import { Helmet } from 'react-helmet'; // can be a hasMeta() HOC in the future
import PropTypes from 'prop-types';
import { decodeHTML, encodeHTML, encodeSpecialCharacters, encodeTitle } from '../../utils';

/*
Helmet component can either encode all special characters or none. We've set it up to encode none and then use either the encodeSpecialCharacters (from the Helmet source code) or the encodeHTML functions to handle encoding on a field-by-field basis.

Most tag values can be passed to encodeSpecialCharacters() but any fields containing HTML, such as meta descriptions containing anchor tags, should be passed to encodeHTML(). We may not have to encode fields where we aren't expecting special characters (ex. og:url).
*/

const MetaTags = ({
  title,
  description,
  url,
  ogType,
  ogTitle,
  ogImage,
  ogImageWidth,
  ogImageHeight,
  ogDescription,
  twitterImg,
  twitterDescription,
  keywords,
  canonicalUrl,
  ampUrl,
  isFeaturedContent,
}) => (
  <Helmet encodeSpecialCharacters={false}>
    {title && <title>{encodeTitle(title)}</title>}
    {description && <meta name="description" content={encodeHTML(description)} />}
    {url && <meta property="og:url" content={url} />}
    {ogType && <meta property="og:type" content={ogType} />}
    {ogTitle && <meta property="og:title" content={encodeSpecialCharacters(ogTitle)} />}
    {ogImage && <meta property="og:image" content={ogImage} />}
    {ogImageWidth && <meta property="og:image:width" content={ogImageWidth} />}
    {ogImageHeight && <meta property="og:image:height" content={ogImageHeight} />}
    {ogDescription && <meta property="og:description" content={encodeHTML(ogDescription)} />}
    <meta name="twitter:card" content="summary_large_image" />
    {ogTitle && <meta name="twitter:title" content={encodeSpecialCharacters(ogTitle)} />}
    {twitterImg && <meta name="twitter:image:src" content={twitterImg} />}
    <meta name="twitter:site" content="@137pm" />
    {url && <meta name="twitter:url" content={url} />}
    {isFeaturedContent && <meta name="robots" content="noindex"/>}
    {twitterDescription && <meta name="twitter:description" content={encodeHTML(twitterDescription)} />}
    {keywords && <meta name="keywords" content={keywords} />}
    {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    {ampUrl && <link rel="amphtml" href={ampUrl} />}
  </Helmet>
);

MetaTags.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string,
  ogType: PropTypes.string,
  ogTitle: PropTypes.string,
  ogImage: PropTypes.string,
  ogImageWidth: PropTypes.string,
  ogImageHeight: PropTypes.string,
  ogDescription: PropTypes.string,
  twitterImg: PropTypes.string,
  twitterDescription: PropTypes.string,
  keywords: PropTypes.string,
  canonicalUrl: PropTypes.string,
};

export default MetaTags;
